// DESCRIPTION: Save component for the post form block.
// Returns null — this is a dynamic block rendered server-side.

export default function Save() {
    return null;
}
